import { Button, CommonProps, Heading } from '@beat-venues/ui/react';
import { cva, VariantProps } from 'class-variance-authority';
import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import success from '../../../public/assets/welcome-flow/beat-success-animation.json';
import { NewUserDetail } from '../../pages/welcome';

export const SuccessStepStyles = cva(
    'flex flex-col pb-4 h-full bg-cover justify-around md:justify-start bg-[url(/assets/welcome-flow/bg-success.webp)]'
);

export interface SuccessStepProps
    extends CommonProps,
        VariantProps<typeof SuccessStepStyles> {
    userDetails: NewUserDetail;
}

export const Success = ({
    className,
    userDetails,
}: SuccessStepProps): JSX.Element => {
    const { t } = useTranslation('');

    const [showFirst, setShowFirst] = useState(false);
    const [showSecond, setShowSecond] = useState(false);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const timer1 = setTimeout(() => {
            setShowFirst(true);
        }, 1500);

        const timer2 = setTimeout(() => {
            setShowSecond(true);
        }, 2200);

        const timer3 = setTimeout(() => {
            setShowButton(true);
        }, 3000);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, []);

    return (
        <div className={twMerge(SuccessStepStyles({ className }))}>
            <div className="w-full lg:-mt-12">
                <Lottie animationData={success} loop={false} />
            </div>
            <div className="mb-[10vh] px-8 text-center md:mb-0">
                <div
                    className={`transform transition-all duration-500 ease-out
          ${
              showFirst
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-16 opacity-0'
          }
        `}
                >
                    <Heading as="h2" className="success-text-show">
                        {t('welcome.success.title')}
                    </Heading>
                </div>

                <div
                    className={`transform transition-all duration-500 ease-out
          ${
              showSecond
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-16 opacity-0'
          }
        `}
                >
                    <Heading as="h2" className="success-text-show">
                        {t('welcome.success.subTitle')} {userDetails.firstName}!
                    </Heading>
                </div>

                <div
                    className={`transform transition-all duration-500 ease-out
          ${
              showButton
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-16 opacity-0'
          }
        `}
                >
                    <Button className="w-full" href="/">
                        {t('welcome.success.button')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
